import * as Yup from "yup";

export interface OTPFormValues {
    otp: string;
    password: string;
    confirmPassword: string;
}

export const otpValidationSchema = () => {
    return Yup.object({
        otp: Yup.string()
            .length(6, `OTP must be exactly 6 digits`)
            .required("OTP is required"),
    });
};
